export class Habito {
    id: number;
    orden: string;
    nombre: string;
    fecha: string;
    tipo: string;
    minimo: string;
    maximo: string;
}



// WEBPACK FOOTER //
// ./src/models/habito.ts